// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ActionBtn--1x70k{border-radius:8px;background-color:#5276f7;color:#fff;cursor:pointer}.ActionBtn--1x70k:disabled{opacity:.5;cursor:default}.ActionBtn--1x70k:hover{background-color:_color(\"nebula-light\")}", ""]);
// Exports
exports.locals = {
	"ActionBtn": "ActionBtn--1x70k"
};
module.exports = exports;
